import React, { useContext } from "react";
import { Link } from "react-router-dom";

// Section for Utilities and Context
import './profilecard.css';
import { AuthContext } from "../utils/AuthContext";
import { districtLabel } from "../utils/district";

// Section for Components
import portrait1 from "../assets/portrait-1.png";
import portrait2 from "../assets/portrait-2.png";
import portrait3 from "../assets/portrait-3.png";
import portrait4 from "../assets/portrait-4.png";
import portrait5 from "../assets/portrait-5.png";
import portrait6 from "../assets/portrait-6.png";


export default function ProfileCard(props) {
    const { auth, isAdmin } = useContext(AuthContext);
    const canEdit = isAdmin || auth.user.user_id === props.user_id || (auth.user.contributor && props.user_id === null);

    // console.log(props)

    const randomDefaultImage = () => {
        const defaultPicture = [portrait1, portrait2, portrait3, portrait4, portrait5, portrait6];
        const randomIndex = Math.floor(Math.random() * defaultPicture.length);
        return defaultPicture[randomIndex];
    }

    return (
        <>
            <div className="card profile-card m-0">
                <div className="pc-image-wrapper">
                    <img src={props.profile_picture || randomDefaultImage()}
                    className="profile-card-image" alt={"Photo of " + props.firstName + " " + props.lastName}/>
                    {isAdmin && props.user_id && (
                        <span className="pc-linked-user-badge" title="Linked to a user account">
                            <i className="bi bi-person-fill-check" />
                        </span>
                    )}
                </div>
                <div className="profile-card-name-div">
                    <h5 className="profile-card-name ms-1 my-1"><strong>{props.firstName + " " + props.lastName}</strong>
                    {props.pronouns !== "" && props.pronouns !== null && 
                        (<span className="pronouns ms-1">{"(" + props.pronouns + ")"}</span>)}
                    </h5>
                    
                </div>
                <div className="card-body profile-card-body pt-1">
                    
                    <span className="profile-card-title"><i>{props.title}</i></span><br/>
                    {props.district && <span className="profile-card-district">{districtLabel(props.district)}</span>}
                    <hr className="my-2"/>
                    {props.division_id
                        ? <Link className="profile-card-org" to={`/division/${props.division_id}`}>{props.organization}</Link>
                        : props.organization_id
                        ? <Link className="profile-card-org" to={`/organization/${props.organization_id}`}>{props.organization}</Link>
                        : <a className="profile-card-org" href={props.website} target="_blank" rel="noopener noreferrer">{props.organization}</a>
                    }<br/>
                    <span className="profile-card-address ">{props.address}
                        {props.suite_number && `, Suite ${props.suite_number}`}
                    </span><br/>
                    <span className="profile-card-csz ">{props.city}, {props.stateCode} {props.zipCode}</span>
                    <hr className="my-2"/>
                    <a href={"mailto:" + props.email} className="profile-card-email"><i className="bi bi-envelope-at"> </i>{props.email}</a>
                    {props?.personal_email && (
                        <a href={"mailto:" + props.personal_email} className="profile-card-email"><i className="bi bi-envelope-at"> </i>{props.personal_email}</a>
                    )}                    
                    <p className="profile-card-phone mb-0"><i className="bi bi-telephone"> </i>{props.phone}</p>
                    {props?.mobile_phone && (
                        <p className="profile-card-phone mb-0"><i className="bi bi-phone"> </i>{props.mobile_phone}</p>
                    )}
                    {props?.lobby_filer_id && (
                        <p className="profile-card-lobby-id mb-0"><i className="bi bi-bank"> </i>Cal-Access ID: <a className="pc-lobby-id-link" href={`https://cal-access.sos.ca.gov/Lobbying/Lobbyists/Detail.aspx?id=${props.lobby_filer_id}`} target="_blank" rel="noopener noreferrer" alt={"Cal-Access Web Page for " + props.firstName + " " + props.lastName}>{props.lobby_filer_id}</a></p>
                    )}                    
                <div className="pci-div pt-2">
                    <div className="row">
                        <div className="col-10">
                            {props.linkedin_url && (
                                <a className="socials-link" href={props.linkedin_url} target="_blank" rel="noreferrer"><i className="bi bi-linkedin pci-socials me-2" /></a>
                            )}
                            {props.facebook_url && (
                                <a className="socials-link" href={props.facebook_url} target="_blank" rel="noreferrer"><i className="bi bi-facebook pci-socials me-2" target="_blank"/></a>
                            )}
                            {props.youtube_url && (
                                <a className="socials-link" href={props.youtube_url} target="_blank" rel="noreferrer"><i className="bi bi-youtube pci-socials me-2" target="_blank"/></a>
                            )}
                            {props.threads_url && (
                                <a className="socials-link" href={props.threads_url} target="_blank" rel="noreferrer"><i className="bi bi-threads pci-socials me-2" target="_blank"/></a>
                            )}
                            {props.twitter_url && (
                                <a className="socials-link" href={props.twitter_url} target="_blank" rel="noreferrer"><i className="bi bi-twitter-x pci-socials me-2" target="_blank"/></a>
                            )}
                            {props.instagram_url && (
                                <a className="socials-link" href={props.instagram_url} target="_blank" rel="noreferrer"><i className="bi bi-instagram pci-socials me-2" target="_blank"/></a>
                            )}
                            {props.tiktok_url && (
                                <a className="socials-link" href={props.tiktok_url} target="_blank" rel="noreferrer"><i className="bi bi-tiktok pci-socials me-2" target="_blank"/></a>
                            )}
                            {props.bluesky_url && (
                                <a className="socials-link" href={props.bluesky_url} target="_blank" rel="noreferrer"><i className="bi bi-bluesky pci-socials me-2" target="_blank"/>
                                </a>
                                
                            )}
                        </div>
                        <div className="col-1 me-0">
                            {canEdit && (
                                <i className="bi bi-pencil-square edit-icon-pci ms-2" alt="Edit PCI Button" data-bs-toggle="modal" data-bs-target="#editPCIModal" />
                            )}
                        </div>

                    </div>
                    
                </div>

                </div>
            </div>
           
        </>
    )
}